import { render } from "./WCCartRemoveButton.vue?vue&type=template&id=004feea3"
import script from "./WCCartRemoveButton.vue?vue&type=script&lang=js"
export * from "./WCCartRemoveButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__